module.exports = __webpack_public_path__ + "images/category_lp/common/frame-advantage@2x_4e83a1aa0734dc2fe27c24db73b9e389.png";